import {
  ColDef,
  GridOptions,
  RowSelectionOptions,
  SelectionColumnDef,
} from 'ag-grid-enterprise';

export const DEFAULT_COLUMN_DEFINITION: ColDef = {
  sortable: true,
  filter: true,
  resizable: true,
  enablePivot: false,
  enableRowGroup: true,
  filterParams: {
    buttons: ['reset'],
  },
  menuTabs: ['filterMenuTab', 'generalMenuTab'],
  cellClass: 'line-height-30',
};

export const DEFAULT_SELECTION_COLUMN_DEFINITION: SelectionColumnDef = {
  sortable: false,
  resizable: false,
  suppressHeaderMenuButton: true,
  suppressHeaderContextMenu: true,
  flex: 1,
  maxWidth: 50,
  pinned: 'left',
  lockPinned: true,
};

export const DEFAULT_SINGLE_ROW_SELECTION: RowSelectionOptions = {
  mode: 'singleRow',
  checkboxes: false,
  enableClickSelection: true,
};

export const DEFAULT_MULTI_ROW_SELECTION: RowSelectionOptions = {
  mode: 'multiRow',
  selectAll: 'currentPage',
  checkboxes: true,
  headerCheckbox: true,
  enableClickSelection: true,
  enableSelectionWithoutKeys: true,
};

export const DEFAULT_GRID_OPTIONS: GridOptions = {
  tooltipShowDelay: 250,
};
